import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, H2 } from '.';
import Translate from './translate';
import { withScriptjs, withGoogleMap, GoogleMap, Polygon } from "react-google-maps";
import { convertLocation, convertPolygon } from '$lib/normalize';
import DrawingManager from "react-google-maps/lib/components/drawing/DrawingManager";
import { searchAreas, getArea } from '../../api';
import flatten from 'lodash/flatten';
import CSSModules from 'react-css-modules';
import style from './area-picker.scss';
import MapSkin from '$constants/map-skin.json';
import { Spinner, AutoComplete } from '$common';


let defaultCenter = 'POINT(28.999099731445312, 41.01928287604562)';

const Map = withScriptjs(withGoogleMap( props =>
    <GoogleMap
      ref={map => {
        if(map) props.self.map = map;
      }}
      defaultZoom={10}
      defaultCenter={convertLocation(props.defaultCenter)}
      defaultOptions={{ styles: MapSkin }}
    >
      <DrawingManager
        defaultOptions={{
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
              google.maps.drawing.OverlayType.POLYGON,
              google.maps.drawing.OverlayType.RECTANGLE
            ]
          }
        }}
      />
      {
        props.polygon ? convertPolygon(props.polygon).map( (item, index) => (
          <Polygon
            ref={polygon => {
              props.self.fitBounds(item);
            }}
            strokeColor="#13a168"
            strokeOpacity={0.8}
            strokeWeight={2}
            fillColor="#13a168"
            fillOpacity={2}
            paths={item}
            key={index}
          />
        )) : null
      }
    </GoogleMap>
));

@CSSModules(style)
export default class AreaPicker extends Component {
  static contextTypes = {
    formFieldName: PropTypes.string,
    getFormValue: PropTypes.func
  };

  state = {
    polygon: null
  };

  get name() {
    return this.props.name || this.context.formFieldName;
  }

  get value() {
    return this.props.value || this.context.getFormValue(this.name);
  }

  componentWillMount() {
    navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      defaultCenter = `POINT(${longitude}, ${latitude})`;
    }, () => {
      defaultCenter = 'POINT(28.999099731445312, 41.01928287604562)';
    });

    if (this.value) {
      this.getPolygon();
    }
  }

  async handleSelection(suggestion_id) {
    const { data: area } = await getArea(suggestion_id);

    this.points = [];
    this.setState({ polygon: area.polygon, suggestions: null });
  }

  fitBounds(item) {
    this.points = [...this.points, ...item[0]];
    const fitBoundTimeoutInterval = 250;
    
    if (this.fitBoundTimeout) clearTimeout(this.fitBoundTimeout);
    this.fitBoundTimeout = setTimeout(::this.applyFitBounds, fitBoundTimeoutInterval);
  }

  applyFitBounds() {
    var bounds = new google.maps.LatLngBounds();
    this.points.forEach(point => {
      bounds.extend({
        lat: point.lat,
        lng: point.lng
      });
    });
    this.map.fitBounds(bounds);
  }

  async getPolygon() {
    const { data: area } = await getArea(this.value);
    this.points = [];

    this.setState({ polygon: area.polygon, placeholder: area.name });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !!(nextState.suggestions || this.state.polygon !== nextState.polygon)
  }

  render() {
    const { polygon, placeholder } = this.state;
    const { height } = this.props;

    return (
      <div styleName="root" style={{ position: 'relative' }}>
        <H2 style={{ marginLeft: '0', fontSize: '13px' }}>{Translate.get('area_name')}</H2>

        <AutoComplete searchEndpoint={searchAreas} onChange={::this.handleSelection} placeholder={placeholder}/>

        <br /><br />

        <Map
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
          loadingElement={
            <div style={{ height: height }} />
          }
          containerElement={
            <div style={{ height: height }} />
          }
          mapElement={
            <div style={{ height: height }} />
          }
          defaultCenter={defaultCenter}
          polygon={polygon}
          self={this}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/area-picker.js